import React from 'react';
import './LoadingOverlay.css';
import yocilabLogo from '../assets/img/YOCILAB-01.svg';

const LoadingOverlay = ({ 
  show = true, 
  message = 'Loading...', 
  darkBackground = true 
}) => {
  if (show === false) return null;

  return (
    <div className={`loading-overlay ${darkBackground ? 'dark' : 'light'}`}>
      <div className="loading-content">
        <div className="loading-logo-container">
          <img 
            src={yocilabLogo} 
            alt="YOCILAB" 
            className="loading-logo"
          />
          <div className="loading-spinner-ring"></div>
        </div>
        <div className="loading-text">
          <h3>{message}</h3>
          <div className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  );
};

// Loading overlay for specific sections
export const SectionLoading = ({ show = false, message = 'Loading content...' }) => {
  if (!show) return null;

  return (
    <div className="section-loading">
      <div className="section-loading-content">
        <div className="loading-spinner-small"></div>
        <span>{message}</span>
      </div>
    </div>
  );
};

// Inline loading for small components
export const InlineLoading = ({ show = false, size = 'medium' }) => {
  if (!show) return null;

  return (
    <div className={`inline-loading ${size}`}>
      <div className="inline-spinner"></div>
    </div>
  );
};

export default LoadingOverlay;